import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import '../styles/InputGroup.scss';

const InputGroup = (props) => {
    let className = 'input-group';
    className += ` input-group-${props.direction}`;
    if (props.className) {
        className += ` ${props.className}`;
    }

    return (
        <div className={className}>
            {(props.title)
                ? <Typography className="title">{props.title}</Typography>
                : null
            }
            <div className="group"
                 style={{flexDirection: props.direction}}
            >
                {props.children}
            </div>
        </div>
    );
};

InputGroup.propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
    direction: PropTypes.oneOf(['row', 'column']),
};

InputGroup.defaultProps = {
    direction: 'column',
};

export default InputGroup;
